import { useState } from "react";
import crypto from "crypto-js";
import env from "../../config";
const SSOHandler = () => {
  const [ssodata, setssodata] = useState("");
  const decript_data = (payload, app) => {
    const ciphertext = crypto.AES.decrypt(payload, app.key).toString(
      crypto.enc.Utf8
    );
    setssodata(ciphertext);
  };
  const checkSSO = () => {
    const key = new Promise((resolve) => {
      window.parent.postMessage({ message: "REQUEST_USER_DATA" }, "*");
      const temp = window.addEventListener("message", ({ data }) => {
        if (data.message === "REQUEST_USER_DATA_RESPONSE") {
          const sso = {
            app_id: env.GHL.APP_ID,
            key: env.GHL.SSO_KEY,
          };
          decript_data(data.payload, sso);
        } else {
        }
      });
    });
  };
  return {
    SSO: ssodata,
    checkSSO: checkSSO,
  };
};
export default SSOHandler;
